import React from "react";
import styles from "./TeamCallHoldDetail.module.scss";
import {Modal} from "antd";
import {URButton} from "../../../shared/widgets/button";
import { initiateCall, initiateGroupCall } from "../../../base/callService/callService";
import { storeHoldTeam } from "../../../base/callService/store_mining";

type TeamCallHoldProps = {holdTeamCall: any};

const TeamCallHold = ({holdTeamCall}: TeamCallHoldProps) => {
 

  const anotherCallMake = () => {
    if (holdTeamCall.callType === "Normal") { initiateCall(holdTeamCall.internalUsers, 'audio') }
    else {
      if (typeof (holdTeamCall.internalUsers) === 'string') {
        initiateGroupCall('single', holdTeamCall.internalUsers);
      }
      else {
        initiateGroupCall('multi', holdTeamCall.internalUsers, holdTeamCall.externalUsers);
      }
    }
    closeHoldCall();
  };

  const closeHoldCall = () => {
    storeHoldTeam(false,'',''|| [],[])
  };

  return (
    <>
      {holdTeamCall.isTeamCallHold === true && (
        <Modal visible={holdTeamCall.isTeamCallHold} className={`${styles.clearchatmodal} ${"modaloverwrite"}`}>
          <span className={`icon_close ${styles.cursorTop}`} onClick={closeHoldCall} />
          <h2> Can&apos;t Connect</h2>
          <p>
            If you start a new call, the current call will be on hold for you but the participants continue with the
            call. Are you okay to continue?
          </p>
          <div className={styles.footersection}>
            <URButton className={styles.cancelbtn} name="Cancel" onClick={closeHoldCall}></URButton>
            <URButton className={styles.okaybtn} onClick={anotherCallMake} name="Okay"></URButton>
          </div>
        </Modal>
      )}
    </>
  );
};

export default TeamCallHold;